import { ArrowDownRight, ArrowUpRight, Info } from "lucide-react";

export default function KpiCard({ label, value, suffix, delta, deltaLabel, icon: Icon, accent = "violet", testid, tooltip }) {
  const positive = delta != null && delta >= 0;
  const accentMap = {
    violet: "from-violet-500 to-purple-600",
    blue: "from-blue-500 to-cyan-500",
    rose: "from-rose-500 to-pink-500",
    amber: "from-amber-500 to-orange-500",
    emerald: "from-emerald-500 to-teal-500",
  };

  return (
    <div
      data-testid={testid}
      className="group relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-5 shadow-sm hover:shadow-lg hover:shadow-violet-200/50 hover:-translate-y-0.5 transition-all duration-300"
    >
      <div className={`absolute -top-8 -right-8 h-24 w-24 rounded-full bg-gradient-to-br ${accentMap[accent]} opacity-10 blur-2xl group-hover:opacity-20 transition`} />
      <div className="flex items-start justify-between">
        <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-500 flex items-center gap-1">
          {label}
          {tooltip && (
            <span className="relative group/tip">
              <Info className="w-3 h-3 text-slate-400 cursor-help" />
              <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 hidden group-hover/tip:block w-48 px-2 py-1 text-[10px] font-normal normal-case tracking-normal text-white bg-slate-800 rounded-lg shadow-lg z-50">
                {tooltip}
              </span>
            </span>
          )}
        </div>
        {Icon && (
          <div className={`h-9 w-9 rounded-xl bg-gradient-to-br ${accentMap[accent]} text-white flex items-center justify-center shadow-md`}>
            <Icon className="w-4 h-4" />
          </div>
        )}
      </div>
      <div className="mt-3 flex items-baseline gap-1">
        <span className="text-3xl font-bold text-slate-900 tracking-tight">{value}</span>
        {suffix && <span className="text-sm text-slate-500 font-medium">{suffix}</span>}
      </div>
      {delta != null && (
        <div className="mt-3 flex items-center gap-2">
          <span
            className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold ${
              positive ? "bg-emerald-50 text-emerald-700" : "bg-rose-50 text-rose-700"
            }`}
          >
            {positive ? <ArrowUpRight className="w-3 h-3" /> : <ArrowDownRight className="w-3 h-3" />}
            {positive ? "+" : ""}
            {delta}%
          </span>
          {deltaLabel && <span className="text-xs text-slate-500">{deltaLabel}</span>}
        </div>
      )}
    </div>
  );
}
